import Stock from '@/components/Stock/Stock'

let StockRouter = [
    {
        path: '/stock',
        name: 'Stock',
        component: Stock
    },
]

export default StockRouter



// WEBPACK FOOTER //
// ./src/components/Stock/router.js